/**
 * Date Utilities — Single Source of Truth
 * ────────────────────────────────────────
 * Every screen and store must use these functions instead of
 * `new Date().toISOString().split('T')[0]` which returns UTC and
 * shows the wrong day after 8pm EDT / 6pm CDT / 5pm PDT.
 *
 * Import: import { localToday, localDateStr } from '@/lib/date-utils';
 */

/**
 * Returns today's date as YYYY-MM-DD in the user's local timezone.
 * This is the ONLY function that should determine "what day is it."
 */
export function localToday(): string {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

/**
 * Converts a Date object to YYYY-MM-DD in local timezone.
 */
export function localDateStr(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

/**
 * Returns a date N days from today in local timezone.
 */
export function localDateOffset(offsetDays: number): string {
  const d = new Date();
  d.setDate(d.getDate() + offsetDays);
  return localDateStr(d);
}
